import { createIconComponent } from '../../factory/create-icon-component';
export const BellIcon = createIconComponent(
  'BellIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.8233 7.88348C5.5075 4.46249 8.51126 2 12 2C15.4887 2 18.4925 4.46249 19.1767 7.88348L20.4305 14.1525C20.7634 15.817 19.8791 17.4982 18.3278 18.1876C14.3272 19.9657 9.67282 19.9657 5.67217 18.1876C4.12092 17.4982 3.23659 15.817 3.56951 14.1525L4.8233 7.88348Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 19L8.2503 19.5632C8.90889 21.045 10.3784 22 12 22C13.6216 22 15.0911 21.045 15.7497 19.5632L16 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
